import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import React from "react";
import { dialogStyles } from "../../../../../Constants/dialogStyles";
import {
  deleteButtonStyles,
  secondaryButtonStyles,
} from "../../../../../Constants/buttonStyles";
import { inputStyles } from "../../../../../Constants/inputStyles";

const DeleteUsersFromOrgDialog = ({
  openDeleteConfirm,
  setOpenDeleteConfrim,
  setUserNameInput,
  set_User,
  _user,
  userNameInput,
  handleDeleteUser,
}) => {
  return (
    <Dialog
      open={openDeleteConfirm}
      onClose={() => {
        setOpenDeleteConfrim(false);
        setUserNameInput("");
        set_User(null);
      }}
      PaperProps={{ sx: dialogStyles.dialogRoot }}
    >
      <DialogTitle sx={dialogStyles.dialogTitle}>
        Confirm User Deletion
      </DialogTitle>

      <DialogContent sx={dialogStyles.dialogContent} dividers>
        <DialogContentText sx={dialogStyles.dialogContentText}>
          You are about to delete user:{" "}
          <strong>
            {_user?.first_name} {_user?.last_name}
          </strong>
          <br />
          This action is <strong>irreversible</strong>, and all associated data
          will be permanently lost.
        </DialogContentText>

        <DialogContentText sx={dialogStyles.dialogContentText}>
          Please type the full name of the user to confirm:
        </DialogContentText>

        <TextField
          fullWidth
          autoFocus
          variant="outlined"
          placeholder="Enter full name"
          value={userNameInput}
          onChange={(e) => setUserNameInput(e.target.value)}
          sx={inputStyles.textField}
        />
      </DialogContent>

      <DialogActions sx={dialogStyles.dialogActions}>
        <Button
          onClick={() => {
            setOpenDeleteConfrim(false);
            setUserNameInput("");
            set_User(null);
          }}
          sx={secondaryButtonStyles}
        >
          Cancel
        </Button>
        <Button
          onClick={handleDeleteUser}
          disabled={
            !_user ||
            userNameInput.trim() !== `${_user?.first_name} ${_user?.last_name}`
          }
          sx={deleteButtonStyles}
        >
          Delete User
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteUsersFromOrgDialog;
